export const GLOBAL_ROUTING_MODELS_RESET_STATE = 'GLOBAL_ROUTING_MODELS_RESET_STATE';
export const GLOBAL_ROUTING_MODELS_CURRENT_ITEM = 'GLOBAL_ROUTING_MODELS_CURRENT_ITEM';

export const GLOBAL_ROUTING_MODELS_REQUEST_LOADING = 'GLOBAL_ROUTING_MODELS_REQUEST_LOADING';
export const GLOBAL_ROUTING_MODELS_REQUEST_SUCCESS = 'GLOBAL_ROUTING_MODELS_REQUEST_SUCCESS';
export const GLOBAL_ROUTING_MODELS_REQUEST_FAILED = 'GLOBAL_ROUTING_MODELS_REQUEST_FAILED';

export const GLOBAL_ROUTING_MODELS_CURRENT_ACTION = 'GLOBAL_ROUTING_MODELS_CURRENT_ACTION';
export const GLOBAL_ROUTING_MODELS_RESET_ACTION = 'GLOBAL_ROUTING_MODELS_RESET_ACTION';